export const BRAND_NAME = 'ShettyOnline';
// Note: It is the main site url. Ex - sky11.com, etc.
export const BRAND_DOMAIN = 'shettyonline.com';
export const PROVIDER_ID = 'BetFair';
